// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__36Ufc","legacyBtn":"MutateMid_legacyBtn__2t_en"};